import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory, Route, IndexRoute, Redirect, applyRouterMiddleware } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux'
import { persistStore } from 'redux-persist';
import crosstabSync from 'redux-persist-crosstab'
import useScroll from 'react-router-scroll/lib/useScroll';
import createFilter from 'redux-persist-transform-filter';
import configureStore from './redux/store/configureStore';
import PostcodeCheckerDoorToDoorSG from './containers/PostcodeCheckerDoorToDoorSG';
import PostcodeCheckerDoorToDoor from './containers/PostcodeCheckerDoorToDoor';
import PostcodeCheckerCourier from './containers/PostcodeCheckerCourier';
import Announcement from './containers/Announcement';
import AnnouncementSG from './containers/AnnouncementSG';
import SellerRating from './containers/SellerRating';
import SunwayPal from './containers/SunwayPal';
import Feedback from './containers/Feedback'
import ExitIntent from './containers/ExitIntent'
import SunwayPalRedeem from './containers/SunwayPalRedeem';
import UploadFile from './containers/UploadFile';
import CollectionPromo from './containers/CollectionPromo';
import Loader from './components/Loader';
import NoMatch from './components/NoMatch';
import { clearMissingItemsWarning } from './redux/actions/orderSummary';
import { resetError } from './redux/actions/error';
import HttpsRedirect from 'react-https-redirect'
import GiftFinder from './containers/GiftFinder'
import GiftFinderNew from './containers/GiftFinderNew'
import PostcodeCheckerCourierSG from './containers/PostcodeCheckerCourierSG';
import TrackingCTASG from './containers/TrackingCTASG';
import VirtualMessage from './containers/VirtualMessage';
import EInvoiceRequest from './containers/EInvoiceRequest';
import EInvoiceConsolidatedUpload from './containers/EInvoiceConsolidatedUpload';
import 'loaders.css/loaders.min.css';
import 'iframe-resizer/js/iframeResizer.contentWindow';

const store = configureStore(browserHistory);
const history = syncHistoryWithStore(browserHistory, store)

const saveShippingFormFilter = createFilter(
  'form',
  ['shipping']
);

class Root extends Component {
  // state = {
  //   initialized: false
  // }
  constructor(props) {
    super(props);
    this.state = {
      rehydrated: false
    };
  }

  componentWillMount() {
    // persistStore(store, {}, (err, restoredState) => {
    //   this.setState({initialized: true})
    // })
    const persistor = persistStore(store, {
      whitelist: ['cart', 'form', 'ticket'],
      //storage: localforage,
      transforms: [saveShippingFormFilter]
    }, () => {
      this.setState({ rehydrated: true});
    });
    crosstabSync(persistor, { whitelist: ['cart'] });
  }

  handleOnChangeRoute = (prevState, nextState, replace, cb) => {
    const { orderSummary: { missingItems }, error } = store.getState();
    if (missingItems && missingItems.length) {
      store.dispatch(clearMissingItemsWarning());
    }
    if (error) {
      store.dispatch(resetError());
    }
    cb();
  }

  handleOnEnterCheckout = (nextState, replace, cb) => {
    const { cart: { items } } = store.getState();
    if (!items || !items.length) {
      browserHistory.push('/');
    }
    cb();
  }

  render() {
    const { rehydrated } = this.state;
    if(!rehydrated){
      return <Loader isVerticalCenter={true} />
    }
    return (
      <Provider store={store}>
        {/* <HttpsRedirect> */}
          <Router
            history={history}
            render={applyRouterMiddleware(useScroll())}
          >
            <Route path="/postcode/sg/:vendor" component={PostcodeCheckerDoorToDoorSG} />
            <Route path="/postcode/:vendor" component={PostcodeCheckerDoorToDoor} />
            <Route path="/postcode/courier/:vendor/:id" component={PostcodeCheckerCourier} />
            <Route path="/courier/postcodeSG/:vendor/:id" component={PostcodeCheckerCourierSG} />
            <Route path="/announcement/:vendor" component={Announcement} />
            <Route path="/sg/announcement/:vendor" component={AnnouncementSG} />
            <Route path="/seller/rating/:vendor" component={SellerRating} />
            <Route path="/sunwaypal/:gtrid" component={SunwayPal} />
            <Route path="/tracking_cta/sg/:gsrid" component={TrackingCTASG} />
            <Route path="/sunwaypal_redeem" component={SunwayPalRedeem} />
            <Route path="/collection/promo/:collection" component={CollectionPromo} />
            <Route path="/virtualmessage" component={VirtualMessage} />
            <Route path="/feedback" component={Feedback} />
            <Route path="/exit" component={ExitIntent} />
            <Route path="/gift_finder" component={GiftFinder} />
            <Route path="/gift_finder_new" component={GiftFinderNew} />
            <Route path="/upload" component={UploadFile} />
            <Route path="/einvoice_request" component={EInvoiceRequest} />
            <Route path="/einvoice_consolidated_upload" component={EInvoiceConsolidatedUpload} />
            <Route path="404" status={404} component={NoMatch} />
            <Redirect from="*" to="404" />
          </Router>
        {/* </HttpsRedirect> */}
      </Provider>
    );
  }
}

ReactDOM.render((
  <Root />
), document.getElementById('root'));
